import { Inject, Injectable } from '@angular/core';
import { GaTaggingService, GA_TAGS, pushToGa } from '@common/util-foundation';
import { GoogleTagConfig } from '@common/util-models';
import { filterNullUndefined } from '@domgen/dgx-fe-common';
import { ComponentStore } from '@ngrx/component-store';
import { mapTo } from 'rxjs/operators';

@Injectable()
export class ErrorPageGaTaggingService extends ComponentStore<never> {
  // **** Tag as soon as you land and log Common data to GA and end the stream **** //
  readonly commonAndLandingGaTags = this.effect((trigger$) =>
    trigger$.pipe(
      mapTo(this.gaTags.onLoadErrorPageData),
      filterNullUndefined(),
      pushToGa(this.gaTaggingService)
    )
  )();

  constructor(
    @Inject(GA_TAGS) private gaTags: GoogleTagConfig,
    private gaTaggingService: GaTaggingService
  ) {
    super();
  }
}
